import { randomUUID } from '@aloft/toolkit-shared';

// Using session storage to store the session ID
// Session storage is cleared when the browser tab is closed
// Session storage is also associated to one tab and cannot be access by other tabs
export const useSessionID = () => {
  const oldSessionID = sessionStorage.getItem('sessionID');
  if (oldSessionID === null) {
    const newSessionID = randomUUID();
    sessionStorage.setItem('sessionID', newSessionID);
    return newSessionID;
  }
  return oldSessionID;
};
